(() => {
  if (customElements.get('store-locator-map')) return;

  const USA_VALUES = ['usa', 'us', 'united states', 'u.s.', 'u.s.a.'];

  function isUSA(country) {
    return USA_VALUES.includes(country.trim().toLowerCase());
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildInfoWindowContent(loc) {
    let html = '<div class="store-locator__info-window">';

    if (loc.image_url) {
      html += '<div class="store-locator__info-media">';
      html += '<img class="store-locator__info-image" src="' + escapeHtml(loc.image_url) + '" alt="' + escapeHtml(loc.name) + '" width="72" height="48" loading="lazy" decoding="async">';
      html += '</div>';
    }

    html += '<div class="store-locator__info-body">';
    if (loc.name) {
      html += '<span class="store-locator__info-name">' + escapeHtml(loc.name) + '</span>';
    }
    if (loc.address_html) {
      html += '<div class="store-locator__info-address">' + loc.address_html + '</div>';
    }
    if (loc.slug) {
      html += '<a class="store-locator__info-link" href="/pages/' + encodeURIComponent(loc.slug) + '">View store</a>';
    }
    html += '</div></div>';

    return html;
  }

  function buildMapOnlyInfoWindowContent(loc) {
    let html = '<div class="store-locator__info-window">';
    html += '<div class="store-locator__info-body">';

    if (loc.name) {
      html += '<span class="store-locator__info-name">' + escapeHtml(loc.name) + '</span>';
    }
    if (loc.address_html) {
      html += '<div class="store-locator__info-address">' + loc.address_html + '</div>';
    }
    if (loc.phone) {
      html += '<div class="store-locator__info-address">' + escapeHtml(loc.phone) + '</div>';
    }

    html += '</div></div>';

    return html;
  }

  function normalizeLocations(raw) {
    return (Array.isArray(raw) ? raw : [])
      .map((loc) => ({
        name: loc.name || '',
        address_html: loc.address_html || '',
        lat: Number(loc.lat),
        lng: Number(loc.lng),
        state: loc.state || '',
        country: loc.country || '',
        phone: loc.phone || '',
        hours: loc.hours || '',
        map_url: loc.map_url || '',
        slug: loc.slug || '',
        image_url: loc.image_url || ''
      }))
      .filter((loc) => !isNaN(loc.lat) && !isNaN(loc.lng) && loc.lat !== 0 && loc.lng !== 0);
  }

  function waitForGoogleMaps() {
    return new Promise((resolve) => {
      const isReady = () => typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.Map === 'function';

      if (isReady()) {
        resolve();
        return;
      }

      const check = () => {
        if (isReady()) {
          resolve();
          return;
        }
        requestAnimationFrame(check);
      };

      check();
    });
  }

  const MAP_STYLES = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#93b8db' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }
  ];

  function getMapOptions() {
    return {
      zoom: 4,
      center: { lat: 39.8283, lng: -98.5795 },
      disableDefaultUI: true,
      gestureHandling: 'cooperative',
      styles: MAP_STYLES
    };
  }

  const PIN_WIDTH = 28;
  const PIN_HEIGHT = 40;
  const STOCKIST_PIN_WIDTH = 21;
  const STOCKIST_PIN_HEIGHT = 30;
  const OVERLAP_DISTANCE_DESKTOP = 28;
  const OVERLAP_DISTANCE_MOBILE = 22;
  const BACK_MARKER_OPACITY = 1;
  const BACK_MARKER_SCALE_DESKTOP = 0.95;
  const BACK_MARKER_SCALE_MOBILE = 0.86;
  const BACK_MARKER_OFFSET_DESKTOP = 5;
  const BACK_MARKER_OFFSET_MOBILE = 4;
  const PIN_SVG = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 100">
      <path fill="#ffffff" d="M49.853,23.519c-2.15.493-3.383,1.332-4.276,2.136,2.025.493,4.459.941,6.164.455,1.178-.335,2-.874,2.197-1.442.079-.227.051-.437-.082-.622-.475-.66-2.346-.906-4.003-.527Z"/>
      <path fill="#ffffff" stroke="#ffffff" stroke-width="1.5" d="M23.811,30.719c.556,1.339,1.77,2.52,3.266,3.184.248-.324.672-.844,1.208-1.381.169-.168.352-.34.54-.518.857-.804,1.828-1.716,1.949-2.896.053-.515-.086-.984-.389-1.321-.27-.299-.649-.47-1.041-.47-1.59.037-1.956,1.573-1.97,1.639-.05.221-.243.379-.47.385-.238-.006-.43-.152-.488-.363-.016-.058-.413-1.435-2.052-1.681-.173-.026-.351-.04-.53-.041-.481,1.144-.489,2.338-.022,3.463Z"/>
      <path fill="#000000" stroke="#ffffff" stroke-width="1.5" d="M67.946,28.889c-1.981-14.398-13.167-25.895-27.521-28.233-2.597-.423-5.275-.506-7.96-.373-3.088.153-6.031.953-8.912,2.001C4.387,9.252-3.791,32.22,5.729,48.954l2.349,4.129,17.927,31.125,9.034,15.584,7.118-12.212,14.183-24.67,6.386-11.068c.784-1.359,1.47-2.597,2.163-3.995,1.688-3.401,2.854-6.998,3.158-10.819.218-2.734.266-5.468-.102-8.138ZM54.919,25.187c-.331.912-1.32,1.646-2.785,2.068-2.083.6-4.603.523-7.925-.241-1.751,1.867-3.663,4.404-5.841,7.754-.293.45-.595.899-.903,1.34.808-.036,1.51-.196,2.182-.496.244-.524.578-.939,1.02-1.268.994-.738,1.444-.503,1.625-.298.268.305.156.797-.286,1.252-.696.719-1.982,1.231-2.037,1.253l-.057.023c-.08.034-.164.067-.249.099l-.482.191.013-.036c-.742.216-1.53.302-2.438.27-4.546,6.176-9.303,9.306-14.139,9.306l-.181-.003c-1.423-.031-2.841-.42-3.891-1.066-1.409-.868-2.153-2.15-2.153-3.708,0-1.224.786-2.316,1.516-2.938l-.004-.007.295-.224c.078-.055.151-.103.224-.147,1.468-.936,2.56-.968,3.519-.864.801.087,1.305.312,1.497.67.112.209.113.453.002.669-.295.571-.948.369-1.424.221-.157-.049-.319-.099-.483-.137-.719-.166-1.663-.286-2.575.26l-.13.087c-.709.46-1.459,1.46-1.459,2.411,0,1.798,1.605,3.753,5.128,3.798l.116-.002c4.669,0,8.142-3.406,11.877-8.55-1.172-.134-2.088-.158-2.881.306-.11.065-.247.082-.375.048s-.238-.116-.302-.226c-.066-.112-.085-.245-.052-.373.033-.128.115-.236.229-.303,1.229-.718,2.577-.55,4.003-.373l.032.004c.448-.635.916-1.315,1.429-2.075,1.816-2.685,3.475-4.797,5.074-6.458.298-.309.574-.587.836-.843-1.122-.304-2.257-.647-3.357-.979l-.02-.006c-4.392-1.327-8.54-2.581-11.67-1.511l-.376.128v-.004c-1.167.459-2.076,1.162-2.71,2.094.053.006.105.013.157.021,1.222.183,1.953.873,2.347,1.409.392-.607,1.146-1.368,2.474-1.399h0c.68,0,1.328.29,1.785.795.493.546.72,1.286.638,2.082-.158,1.546-1.272,2.592-2.255,3.514-.191.179-.361.339-.518.496-.765.766-1.277,1.488-1.333,1.568-.126.185-.372.261-.583.18-1.905-.725-3.463-2.172-4.168-3.869-.495-1.192-.554-2.456-.175-3.679-.655.201-1.259.583-1.764,1.119-.157.167-.305.352-.437.548-.109.216-.565,1.253-.203,2.964l.005.025c.075.351.199.938-.353,1.14-.169.063-.361.048-.527-.041-.238-.128-.418-.404-.507-.776-.059-.248-.092-.508-.1-.794-.076-1.348.436-2.714,1.403-3.742.805-.856,1.85-1.404,2.952-1.552,1.007-1.866,2.834-3.082,5.291-3.518,4.04-.778,8.975.616,13.328,1.847l.07.02c.723.204,1.407.398,2.088.582,1.733-1.417,3.418-2.231,5.613-2.715,2.256-.497,4.412-.09,5.126.967h0c.346.513.421,1.115.21,1.695Z"/>
    </svg>
  `);

  const STOCKIST_MARKER_SVG =
    'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 24 36">' +
        '<path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0z" fill="#000"/>' +
        '<circle cx="12" cy="12" r="4" fill="#fff"/>' +
      '</svg>'
    );

  class StoreLocatorMap extends HTMLElement {
    constructor() {
      super();
      this.map = null;
      this.markers = [];
      this.markerEntries = [];
      this.projectionOverlay = null;
      this.mapListeners = [];
      this.infoWindow = null;
      this.locations = [];
      this.mapOnly = false;
      this.activeFilter = 'country:US';

      this.onFilterToggle = this.onFilterToggle.bind(this);
      this.onFilterSelect = this.onFilterSelect.bind(this);
      this.onZoomIn = this.onZoomIn.bind(this);
      this.onZoomOut = this.onZoomOut.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onMapIdle = this.onMapIdle.bind(this);
      this.onMapZoomChanged = this.onMapZoomChanged.bind(this);
    }

    connectedCallback() {
      this.mapOnly = this.dataset.mapOnly === 'true';
      this.parseLocations();

      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterContainer = this.querySelector('[data-filter]');
      this.filterList = this.querySelector('[data-filter-list]');
      this.mapContainer = this.querySelector('[data-map]');
      this.zoomInBtn = this.querySelector('[data-zoom-in]');
      this.zoomOutBtn = this.querySelector('[data-zoom-out]');
      this.cardsContainer = this.querySelector('[data-cards]');

      if (!this.mapOnly) {
        this.buildFilterOptions();
        this.updateFilterList(this.activeFilter);
        this.filterCards(this.activeFilter);
      }

      this.setEventListeners();
      this.scheduleMapInit();
    }

    scheduleMapInit() {
      const isReady = () => typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.Map === 'function';

      if (isReady()) {
        this.initMap();
        return;
      }

      waitForGoogleMaps().then(() => {
        if (!this.isConnected) return;
        this.initMap();
      });
    }

    disconnectedCallback() {
      this.removeEventListeners();
      this.removeMapListeners();
      this.destroyProjectionOverlay();
    }

    parseLocations() {
      const scriptEl = this.querySelector('script[type="application/json"][data-locations]');
      let raw = [];

      if (scriptEl) {
        try {
          raw = JSON.parse(scriptEl.textContent);
        } catch (error) {
          console.warn('Store Locator: invalid location data.', error);
        }
      } else if (window.STORE_LOCATIONS) {
        raw = window.STORE_LOCATIONS;
      }

      this.locations = normalizeLocations(raw);
    }

    setEventListeners() {
      if (!this.mapOnly) {
        this.filterToggle?.addEventListener('click', this.onFilterToggle);
        this.filterList?.addEventListener('click', this.onFilterSelect);
        document.addEventListener('click', this.onDocumentClick);
      }

      this.zoomInBtn?.addEventListener('click', this.onZoomIn);
      this.zoomOutBtn?.addEventListener('click', this.onZoomOut);
    }

    removeEventListeners() {
      if (!this.mapOnly) {
        this.filterToggle?.removeEventListener('click', this.onFilterToggle);
        this.filterList?.removeEventListener('click', this.onFilterSelect);
        document.removeEventListener('click', this.onDocumentClick);
      }

      this.zoomInBtn?.removeEventListener('click', this.onZoomIn);
      this.zoomOutBtn?.removeEventListener('click', this.onZoomOut);
    }

    buildFilterOptions() {
      if (!this.filterList) return;

      const countries = [];
      const locationStates = [];

      this.locations.forEach((loc) => {
        const c = loc.country.trim();
        if (c && !countries.some((existing) => existing.toLowerCase() === c.toLowerCase())) {
          countries.push(c);
        }
        const st = (loc.state || '').trim();
        if (st && !locationStates.includes(st)) {
          locationStates.push(st);
        }
      });

      countries.sort((a, b) => a.localeCompare(b));
      locationStates.sort((a, b) => a.localeCompare(b));

      let html = '';
      html += '<li class="store-locator__filter-item" data-filter-value="country:US" aria-selected="true">United States</li>';

      countries.forEach((country) => {
        if (isUSA(country)) return;
        html += '<li class="store-locator__filter-item" data-filter-value="country:' + country + '">' + country + '</li>';
      });

      locationStates.forEach((state) => {
        html += '<li class="store-locator__filter-item" data-filter-value="state:' + state + '">' + state + '</li>';
      });

      this.filterList.innerHTML = html;
    }

    initMap() {
      if (!this.mapContainer) return;

      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.warn('Store Locator: Google Maps API not loaded.');
        return;
      }

      this.map = new google.maps.Map(this.mapContainer, getMapOptions());

      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        if (!this.map) return;
        this.map.setOptions({ styles: MAP_STYLES });
      });

      this.infoWindow = new google.maps.InfoWindow();

      this.initProjectionOverlay();
      this.addMapListeners();

      if (this.mapOnly) {
        this.addMarkers(this.locations);
        this.fitBounds(this.locations);
        return;
      }

      const filtered = this.getFilteredLocations(this.activeFilter);
      this.addMarkers(filtered);
      this.setMapView(this.activeFilter, filtered);
    }

    addMarkers(locations) {
      this.clearMarkers();

      locations.forEach((loc, index) => {
        const baseZIndex = 10 + index;
        const marker = new google.maps.Marker({
          position: { lat: loc.lat, lng: loc.lng },
          map: this.map,
          title: loc.name,
          optimized: false,
          zIndex: baseZIndex,
          icon: this.createPinIcon()
        });

        marker.addListener('click', () => {
          this.bringMarkerToFront(marker);
          if (!this.infoWindow) return;

          const content = this.mapOnly
            ? buildMapOnlyInfoWindowContent(loc)
            : buildInfoWindowContent(loc);

          this.infoWindow.setContent(content);
          this.infoWindow.open(this.map, marker);
        });

        this.markers.push(marker);
        this.markerEntries.push({
          marker,
          baseZIndex
        });
      });

      this.updateOverlapPriority();
    }

    clearMarkers() {
      this.markers.forEach((marker) => marker.setMap(null));
      this.markers = [];
      this.markerEntries = [];
      if (this.infoWindow) this.infoWindow.close();
    }

    setMapView(filter, locations) {
      if (!this.map) return;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const mobilePadding = { top: 40, right: 24, bottom: 40, left: 24 };

      if (filter.startsWith('country:')) {
        const country = filter.replace('country:', '');
        if (country.trim().toLowerCase() === 'us' || isUSA(country)) {
          if (isMobile) {
            this.fitBounds(locations, {
              padding: mobilePadding,
              maxZoom: 4
            });
            return;
          }
          this.setUsaView();
          return;
        }
      }

      if (isMobile) {
        this.fitBounds(locations, {
          padding: mobilePadding,
          maxZoom: 12
        });
        return;
      }

      this.fitBounds(locations);
    }

    setWorldwideView() {
      if (!this.map) return;
      this.map.setCenter({ lat: 20, lng: 0 });
      this.map.setZoom(2);
    }

    setUsaView() {
      if (!this.map) return;
      this.map.setCenter({ lat: 39.8283, lng: -98.5795 });
      this.map.setZoom(4);
    }

    fitBounds(locations, options = {}) {
      if (!this.map || locations.length === 0) return;
      const { padding = 60, maxZoom } = options;

      if (locations.length === 1) {
        this.map.setCenter({ lat: locations[0].lat, lng: locations[0].lng });
        const singleLocationZoom = typeof maxZoom === 'number' ? Math.min(14, maxZoom) : 14;
        this.map.setZoom(singleLocationZoom);
        return;
      }

      const bounds = new google.maps.LatLngBounds();
      locations.forEach((loc) => {
        bounds.extend({ lat: loc.lat, lng: loc.lng });
      });
      this.map.fitBounds(bounds, padding);

      if (typeof maxZoom === 'number') {
        google.maps.event.addListenerOnce(this.map, 'idle', () => {
          if (!this.map) return;
          const zoom = this.map.getZoom();
          if (typeof zoom === 'number' && zoom > maxZoom) {
            this.map.setZoom(maxZoom);
          }
        });
      }
    }

    getFilteredLocations(filter) {
      if (filter === 'worldwide') return this.locations;

      if (filter.startsWith('country:')) {
        const country = filter.replace('country:', '').trim().toLowerCase();
        if (country === 'us') {
          return this.locations.filter((loc) => isUSA(loc.country));
        }
        return this.locations.filter((loc) => loc.country.trim().toLowerCase() === country);
      }

      if (filter.startsWith('state:')) {
        const state = filter.replace('state:', '');
        return this.locations.filter((loc) => loc.state === state);
      }

      return this.locations;
    }

    onFilterToggle(event) {
      event.stopPropagation();
      const isOpen = this.filterContainer.getAttribute('data-open') === 'true';
      const next = isOpen ? 'false' : 'true';
      this.filterContainer.setAttribute('data-open', next);
      this.filterToggle.setAttribute('aria-expanded', next);
    }

    onFilterSelect(event) {
      const item = event.target.closest('[data-filter-value]');
      if (!item) return;

      const value = item.getAttribute('data-filter-value');
      this.activeFilter = value;

      this.filterList.querySelectorAll('[data-filter-value]').forEach((el) => {
        el.setAttribute('aria-selected', 'false');
      });
      item.setAttribute('aria-selected', 'true');

      this.updateFilterList(value);

      const label = this.filterToggle.querySelector('.store-locator__filter-label');
      if (label) label.textContent = item.textContent;
      this.filterContainer.setAttribute('data-open', 'false');
      this.filterToggle.setAttribute('aria-expanded', 'false');

      const filtered = this.getFilteredLocations(value);
      this.addMarkers(filtered);
      this.setMapView(value, filtered);
      this.filterCards(value);
    }

    filterCards(filter) {
      if (!this.cardsContainer) return;
      const cards = this.cardsContainer.querySelectorAll('[data-card]');

      cards.forEach((card) => {
        const country = card.getAttribute('data-card-country') || '';
        const state = card.getAttribute('data-card-state') || '';
        let visible = true;

        if (filter.startsWith('country:')) {
          const filterCountry = filter.replace('country:', '').trim().toLowerCase();
          if (filterCountry === 'us') {
            visible = isUSA(country);
          } else {
            visible = country.trim().toLowerCase() === filterCountry;
          }
        } else if (filter.startsWith('state:')) {
          visible = state === filter.replace('state:', '');
        }

        card.style.display = visible ? '' : 'none';
      });

      const groups = this.cardsContainer.querySelectorAll('[data-country-group]');
      groups.forEach((group) => {
        const hasVisible = group.querySelector('[data-card]:not([style*="display: none"])');
        group.classList.toggle('is-hidden', !hasVisible);
      });

      this.cardsContainer.querySelectorAll('[data-state-group]').forEach((stateGroup) => {
        const hasVisible = stateGroup.querySelector('[data-card]:not([style*="display: none"])');
        stateGroup.classList.toggle('is-hidden', !hasVisible);
      });

      const hideListHeadings = filter.startsWith('state:');
      this.cardsContainer
        .querySelectorAll('.store-locator__country-heading, .store-locator__state-heading')
        .forEach((heading) => {
          heading.classList.toggle('is-hidden', hideListHeadings);
        });
    }

    onZoomIn() {
      if (!this.map) return;
      this.map.setZoom(this.map.getZoom() + 1);
    }

    onZoomOut() {
      if (!this.map) return;
      this.map.setZoom(this.map.getZoom() - 1);
    }

    updateFilterList(activeFilter) {
      if (!this.filterList) return;

      this.filterList.querySelectorAll('[data-filter-value]').forEach((el) => {
        el.classList.toggle('is-hidden', el.getAttribute('data-filter-value') === activeFilter);
      });
    }

    onDocumentClick(event) {
      if (!this.filterContainer?.contains(event.target)) {
        this.filterContainer?.setAttribute('data-open', 'false');
        this.filterToggle?.setAttribute('aria-expanded', 'false');
      }
    }

    addMapListeners() {
      if (!this.map) return;
      this.mapListeners.push(google.maps.event.addListener(this.map, 'idle', this.onMapIdle));
      this.mapListeners.push(google.maps.event.addListener(this.map, 'zoom_changed', this.onMapZoomChanged));
    }

    removeMapListeners() {
      this.mapListeners.forEach((listener) => google.maps.event.removeListener(listener));
      this.mapListeners = [];
    }

    onMapIdle() {
      this.updateOverlapPriority();
    }

    onMapZoomChanged() {
      this.updateOverlapPriority();
    }

    initProjectionOverlay() {
      if (!this.map || this.projectionOverlay) return;

      this.projectionOverlay = new google.maps.OverlayView();
      this.projectionOverlay.onAdd = () => {};
      this.projectionOverlay.draw = () => {};
      this.projectionOverlay.onRemove = () => {};
      this.projectionOverlay.setMap(this.map);
    }

    destroyProjectionOverlay() {
      if (!this.projectionOverlay) return;
      this.projectionOverlay.setMap(null);
      this.projectionOverlay = null;
    }

    getMapProjection() {
      if (!this.projectionOverlay) return null;
      return this.projectionOverlay.getProjection();
    }

    getOverlapDistancePx() {
      return window.matchMedia('(max-width: 749px)').matches ? OVERLAP_DISTANCE_MOBILE : OVERLAP_DISTANCE_DESKTOP;
    }

    getBackMarkerScale() {
      return window.matchMedia('(max-width: 749px)').matches ? BACK_MARKER_SCALE_MOBILE : BACK_MARKER_SCALE_DESKTOP;
    }

    getBackMarkerOffsetPx() {
      return window.matchMedia('(max-width: 749px)').matches ? BACK_MARKER_OFFSET_MOBILE : BACK_MARKER_OFFSET_DESKTOP;
    }

    createPinIcon({ scale = 1, offsetX = 0, offsetY = 0 } = {}) {
      const pinWidth = this.mapOnly ? STOCKIST_PIN_WIDTH : PIN_WIDTH;
      const pinHeight = this.mapOnly ? STOCKIST_PIN_HEIGHT : PIN_HEIGHT;
      const scaledWidth = Math.max(1, Math.round(pinWidth * scale));
      const scaledHeight = Math.max(1, Math.round(pinHeight * scale));
      const anchorX = Math.round((scaledWidth / 2) - offsetX);
      const anchorY = Math.round(scaledHeight - offsetY);

      return {
        url: this.mapOnly ? STOCKIST_MARKER_SVG : PIN_SVG,
        scaledSize: new google.maps.Size(scaledWidth, scaledHeight),
        anchor: new google.maps.Point(anchorX, anchorY)
      };
    }

    resetMarkerVisualState(entry) {
      entry.marker.setZIndex(entry.baseZIndex);
      entry.marker.setOpacity(1);
      entry.marker.setIcon(this.createPinIcon());
    }

    applyLeaderVisualState(entry, zIndex) {
      entry.marker.setZIndex(zIndex);
      entry.marker.setOpacity(1);
      entry.marker.setIcon(this.createPinIcon());
    }

    applyBackgroundVisualState(entry, offsetX, offsetY) {
      entry.marker.setZIndex(entry.baseZIndex);
      entry.marker.setOpacity(BACK_MARKER_OPACITY);
      entry.marker.setIcon(this.createPinIcon({
        scale: this.getBackMarkerScale(),
        offsetX,
        offsetY
      }));
    }

    getLeaderIndexForGroup(group, points) {
      const centroid = group.reduce((accumulator, index) => {
        accumulator.x += points[index].x;
        accumulator.y += points[index].y;
        return accumulator;
      }, { x: 0, y: 0 });

      centroid.x /= group.length;
      centroid.y /= group.length;

      let leaderIndex = group[0];
      let minimumDistance = Infinity;

      group.forEach((index) => {
        const point = points[index];
        const distance = Math.hypot(point.x - centroid.x, point.y - centroid.y);
        if (distance < minimumDistance) {
          minimumDistance = distance;
          leaderIndex = index;
        }
      });

      return leaderIndex;
    }

    getClusterOffset(offsetOrder) {
      const baseRadius = this.getBackMarkerOffsetPx();
      const vectors = [
        { x: -1, y: -1 },
        { x: 1, y: -1 },
        { x: -1, y: 1 },
        { x: 1, y: 1 },
        { x: 0, y: -1 },
        { x: 0, y: 1 },
        { x: -1, y: 0 },
        { x: 1, y: 0 }
      ];

      const vector = vectors[offsetOrder % vectors.length];
      const ring = Math.floor(offsetOrder / vectors.length) + 1;
      const radius = baseRadius * ring;

      return {
        x: Math.round(vector.x * radius),
        y: Math.round(vector.y * radius * 0.75)
      };
    }

    updateOverlapPriority() {
      if (!this.map || this.markerEntries.length === 0) return;

      this.markerEntries.forEach((entry) => {
        this.resetMarkerVisualState(entry);
      });

      if (this.mapOnly) return;

      const projection = this.getMapProjection();
      if (!projection || this.markerEntries.length < 2) return;

      const points = this.markerEntries.map((entry) => projection.fromLatLngToDivPixel(entry.marker.getPosition()));
      if (points.some((point) => !point)) return;

      const groups = this.groupOverlappingMarkers(points, this.getOverlapDistancePx());
      let groupOffset = 0;

      groups.forEach((group) => {
        if (group.length < 2) return;

        const leaderIndex = this.getLeaderIndexForGroup(group, points);
        const leaderEntry = this.markerEntries[leaderIndex];
        this.applyLeaderVisualState(leaderEntry, google.maps.Marker.MAX_ZINDEX + 200 + groupOffset);

        let offsetOrder = 0;
        group.forEach((index) => {
          if (index === leaderIndex) return;
          const entry = this.markerEntries[index];
          const offset = this.getClusterOffset(offsetOrder);
          this.applyBackgroundVisualState(entry, offset.x, offset.y);
          offsetOrder += 1;
        });

        groupOffset += 1;
      });
    }

    groupOverlappingMarkers(points, overlapDistance) {
      const groups = [];
      const visited = new Set();

      points.forEach((_, seedIndex) => {
        if (visited.has(seedIndex)) return;

        const group = [];
        const queue = [seedIndex];

        while (queue.length > 0) {
          const currentIndex = queue.shift();
          if (visited.has(currentIndex)) continue;

          visited.add(currentIndex);
          group.push(currentIndex);

          points.forEach((candidatePoint, candidateIndex) => {
            if (visited.has(candidateIndex) || candidateIndex === currentIndex) return;

            const currentPoint = points[currentIndex];
            const distance = Math.hypot(
              candidatePoint.x - currentPoint.x,
              candidatePoint.y - currentPoint.y
            );

            if (distance <= overlapDistance) {
              queue.push(candidateIndex);
            }
          });
        }

        groups.push(group);
      });

      return groups;
    }

    bringMarkerToFront(activeMarker) {
      if (!this.mapOnly) {
        this.updateOverlapPriority();
      }

      this.markerEntries.forEach((entry) => {
        if (entry.marker !== activeMarker) return;
        entry.marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);
        if (!this.mapOnly) {
          entry.marker.setOpacity(1);
          entry.marker.setIcon(this.createPinIcon());
        }
      });
    }
  }

  customElements.define('store-locator-map', StoreLocatorMap);
})();
